module.exports = __webpack_public_path__ + "img/elevate-logo-white.7b3309d4.png";